import React, { Component } from 'react';

// const baseUrl = 'https://us-central1-suacode-ai.cloudfunctions.net/api'

class Verify extends Component {
  constructor(props) {
    super(props)
    this.state = {
      imageLoaded: false,
      loading: true,
      error: false,
      errorMsg: '',
      data: {
        certificateUrl: '',
        course: '',
        cohortPeriod: {
          from: '',
          to: ''
        },
        userName: ''

      }
    }
    this.showDetails = this.showDetails.bind(this)
    this.onImageLoaded = this.onImageLoaded.bind(this)
  }

  async componentDidMount() {

    let graduateId = this.props.match.params['graduateId']
    try {

      const response = await fetch(`/verification/${graduateId}`);
      console.log(response)
      const json = await response.json();

      if (json['data'] === undefined && json['success']) throw Error('No data available')
      this.setState({ data: json.data, loading: false, error: false });

    } catch (e) {
      console.log(e)
      this.setState({ loading: false, errorMsg: e.toString(), error: true });
    }

  }

  onImageLoaded() {
    this.setState({ imageLoaded: true })
  }

  showDetails() {
    let data = this.state.data
    console.log(data)
    let loading = this.state.loading
    let error = this.state.error
    let imageLoaded = this.state.imageLoaded

    let certificateUrl = data.certificateUrl || ''
    let userName = data.userName || ''
    let course = data.course || ''

    let cohortPeriodFrom = data.cohortPeriod.from
    let cohortPeriodTo = data.cohortPeriod.to

    let errorMsg = this.state.errorMsg
    let from, to

    from = new Date(cohortPeriodFrom._seconds * 1000 + cohortPeriodFrom._nanoseconds / 1000000).toDateString()
    to = new Date(cohortPeriodTo._seconds * 1000 + cohortPeriodTo._nanoseconds / 1000000).toDateString()


    if (error) {
      return (<div>
        <p>There was an error loading details. Please try again</p>
        <p>{errorMsg}</p>
      </div>)
    }
    else if (!error && loading) return 'Loading ...'
    else if (!error && !loading && Object.keys(data).length !== 0)
      return (
        <div className="center">
          <div className="card-image">
            {!imageLoaded && certificateUrl !== '' && 'Loading certificate...'}
            <img onLoad={this.onImageLoaded} placeholder="" alt="Image of certificate" src={certificateUrl} />
          </div>
          <h3>{userName} participated in and successfully completed</h3>
          <h4>{course}</h4>
          <h5>Held on {from} to {to}</h5>
        </div>)

  }

  render() {
    return (
      <div className="container centered-row">
        <div className="col s12 m7">
          <div className="card">
            <div className="content">
              <div className="padding20">
                {this.showDetails()}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Verify